import React, { useRef, useState } from "react";
import ImageShowCaseStyle from "css/core/ImageShowCase.module.css";
import CardHolder from "./CardHolder";

const ImageShowCase = ({ Images }) => {
  const HeroImage = useRef();
  const [activeImage, setActiveImage] = useState(0);

  const handelImageClick = (img, index) => {
    setActiveImage(index);
    HeroImage.current.style.backgroundImage = `url(${img})`;
  };

  const ScrollRight = () => {
    const prev = activeImage ? activeImage - 1 : Images.length - 1;
    setActiveImage(prev);
    HeroImage.current.style.backgroundImage = `url(${Images[prev]})`;
  };

  const ScrollLeft = () => {
    const next = activeImage === Images.length - 1 ? 0 : activeImage + 1;
    setActiveImage(next);
    HeroImage.current.style.backgroundImage = `url(${Images[next]})`;
  };

  return (
    <div className={ImageShowCaseStyle.container}>
      <div
        ref={HeroImage}
        className={ImageShowCaseStyle.HeroElementWarper}
        style={{ backgroundImage: `url(${Images[0]})` }}
      >
        <span className={ImageShowCaseStyle.imageIndex}>
          {activeImage + 1}/{Images.length}
        </span>
        <span onClick={ScrollRight} className={ImageShowCaseStyle.leftArrow}>
          <span className="material-icons-round md-18">arrow_back_ios</span>
        </span>
        <span onClick={ScrollLeft} className={ImageShowCaseStyle.rightArrow}>
          <span className="material-icons-round md-18">arrow_forward_ios</span>
        </span>
      </div>
      <CardHolder>
        {Images.map((item, index) => {
          return (
            <div
              onClick={() => handelImageClick(item, index)}
              key={index}
              className={`${ImageShowCaseStyle.SliderImage} ${
                activeImage === index && ImageShowCaseStyle.active
              }`}
              style={{ backgroundImage: `url(${item})` }}
            ></div>
          );
        })}
      </CardHolder>
    </div>
  );
};

export default ImageShowCase;
